<input #input (keydown)="onKeyDown($event)" [(ngModel)]="value" style="width: 100%">